<script setup lang="ts">
defineProps<{
  message?: string
}>()
</script>

<template>
  <div class="text-center p-3 text-muted">
    {{ message || $t('notification.list.empty') }}
  </div>
</template>
